import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import DsTimeline from '../../molecules/Timeline';

const timeLineData = (booking, context) => {
  //DATES
  const checkIn = booking && booking.rooms[0] && booking.rooms[0].check_in;
  const freeCancellation = booking.cancellation_limit_date;
  //FORMAT DATES TO YYYY-MM-DD
  const today = moment().format('YYYY-MM-DD');
  // Landmark format
  return [{
    id: 'purchase',
    icon: 'tl-dot',
    date: booking.reservation_date,
    title: context.t('Purchase'),
    status: 'done',
  },
  {
    id: 'today',
    icon: 'tl-dot-sm',
    date: today,
    title: context.t('Today'),
    status: 'done',
  },
  {
    id: 'cancelationFree',
    icon: 'tl-dot-sm',
    date: freeCancellation,
    title: context.t('Free cancelation'),
    tooltip: `${context.t('Confirm and close')} ${freeCancellation}`,
  },
  {
    id: 'checkIn',
    icon: 'tl-dot',
    date: checkIn,
    title: context.t('Check-in'),
    status: 'danger',
  }];
};
const TimelinePurchase = ({ booking }, context) => (
        <DsTimeline list={timeLineData(booking, context)}/>
);

TimelinePurchase.contextTypes = {
  t: PropTypes.func.isRequired,
};
TimelinePurchase.propTypes = {
  booking: PropTypes.object.isRequired,
};

export default TimelinePurchase;
